export function deepCloneWithoutKey(obj, keyToRemove, seen = new WeakMap()) {
    if (obj === null || typeof obj !== "object") return obj;

    if (seen.has(obj)) return seen.get(obj);

    const clone = Array.isArray(obj) ? [] : {};
    seen.set(obj, clone);

    for (const key in obj) {
        if (key === keyToRemove) continue;
        clone[key] = deepCloneWithoutKey(obj[key], keyToRemove, seen);
    }

    return clone;
}
